"use client";
import * as d from "react";
import { u as xe } from "./useControlled-B2rPEZCb.mjs";
import { u as y } from "./useEventCallback-CjuAhyNz.mjs";
import { c as Pe, m as Ee, u as be } from "./useRenderElement-B8V3_e8R.mjs";
import { u as U } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { v as ye } from "./visuallyHidden-DPuANzJJ.mjs";
import { u as Re } from "./useBaseUiId-a-UPSsPQ.mjs";
import { u as ge } from "./useButton-CQeWQM5o.mjs";
import { u as Ne } from "./FieldRootContext-Cj7-dNhd.mjs";
import { u as Ge, a as Ie } from "./useFieldControlValidation-B3M7EPH2.mjs";
import { u as Be } from "./FormContext-CYX6HnEQ.mjs";
import { j as w } from "./jsx-runtime-CJ-St4mQ.mjs";
let K = /* @__PURE__ */ function(n) {
  return n.checked = "data-checked", n.unchecked = "data-unchecked", n.disabled = "data-disabled", n.readonly = "data-readonly", n.required = "data-required", n.valid = "data-valid", n.invalid = "data-invalid", n.touched = "data-touched", n.dirty = "data-dirty", n.filled = "data-filled", n.focused = "data-focused", n;
}({});
function Fe(n) {
  return d.useMemo(() => ({
    checked(r) {
      return n.indeterminate ? {} : r ? {
        [K.checked]: ""
      } : {
        [K.unchecked]: ""
      };
    }
  }), [n.indeterminate]);
}
const L = /* @__PURE__ */ d.createContext(void 0);
process.env.NODE_ENV !== "production" && (L.displayName = "CheckboxGroupContext");
function we(n = !0) {
  const r = d.useContext(L);
  if (r === void 0 && !n)
    throw new Error("Base UI: CheckboxGroupContext is missing. CheckboxGroup parts must be placed within <CheckboxGroup>.");
  return r;
}
const M = /* @__PURE__ */ d.createContext(void 0);
process.env.NODE_ENV !== "production" && (M.displayName = "CheckboxRootContext");
function Qe() {
  const n = d.useContext(M);
  if (n === void 0)
    throw new Error("Base UI: CheckboxRootContext is missing. Checkbox parts must be placed within <Checkbox.Root>.");
  return n;
}
const Me = {}, je = "data-parent", Se = /* @__PURE__ */ d.forwardRef(function(r, X) {
  const {
    checked: Y,
    className: qe,
    defaultChecked: $ = !1,
    disabled: z = !1,
    id: R,
    indeterminate: g = !1,
    inputRef: J,
    name: Q,
    onCheckedChange: W,
    parent: c = !1,
    readOnly: h = !1,
    render: He,
    required: k = !1,
    value: C,
    nativeButton: Z = !0,
    ...D
  } = r, {
    clearErrors: A
  } = Be(), {
    disabled: ee,
    labelId: ne,
    name: te,
    setControlId: v,
    setDirty: oe,
    setFilled: V,
    setFocused: j,
    setTouched: ae,
    state: S,
    validationMode: N,
    validityData: ie
  } = Ne(), e = we(), x = e == null ? void 0 : e.parent, G = x && e.allValues, l = ee || (e == null ? void 0 : e.disabled) || z, P = te ?? Q, o = C ?? P;
  let I = {};
  G && (c ? I = e.parent.getParentProps() : o && (I = e.parent.getChildProps(o)));
  const de = y(W), {
    checked: q = Y,
    indeterminate: E = g,
    onCheckedChange: B,
    ...re
  } = I, u = e == null ? void 0 : e.value, H = e == null ? void 0 : e.setValue, O = e == null ? void 0 : e.defaultValue, f = d.useRef(null), {
    getButtonProps: se,
    buttonRef: ce
  } = ge({
    disabled: l,
    native: Z
  }), le = Ge(), i = (e == null ? void 0 : e.fieldControlValidation) ?? le, [s, ue] = xe({
    controlled: o && u && !c ? u.includes(o) : q,
    default: o && O && !c ? O.includes(o) : $,
    name: "Checkbox",
    state: "checked"
  }), m = Re(R);
  U(() => {
    const t = f == null ? void 0 : f.current;
    if (t)
      return e ? v(R ?? null) : t.closest("label") == null && v(m), () => {
        v(void 0);
      };
  }, [e, m, R, v]), Ie({
    enabled: !e,
    id: m,
    commitValidation: i.commitValidation,
    value: s,
    controlRef: f,
    name: P,
    getValue: () => s
  });
  const p = d.useRef(null), fe = Pe(J, p, i.inputRef);
  U(() => {
    p.current && (p.current.indeterminate = E, s && V(!0));
  }, [s, E, V]);
  const me = y(() => j(!0)), pe = y(() => {
    const t = p.current;
    t && (ae(!0), j(!1), N === "onBlur" && i.commitValidation(e ? u : t.checked));
  }), he = y((t) => {
    var a;
    t.defaultPrevented || h || (t.preventDefault(), (a = p.current) == null || a.click());
  }), ke = Ee(
    {
      checked: s,
      disabled: l,
      // parent checkboxes unset `name` to be excluded from form submission
      name: c ? void 0 : P,
      // Set `id` to stop Chrome warning about an unassociated input
      id: `${m}-input`,
      required: k,
      ref: fe,
      style: ye,
      tabIndex: -1,
      type: "checkbox",
      "aria-hidden": !0,
      onChange(t) {
        if (t.nativeEvent.defaultPrevented)
          return;
        const a = t.target.checked;
        if (oe(a !== ie.initialValue), ue(a), B == null || B(a, t.nativeEvent), de(a, t.nativeEvent), A(P), e || (V(a), N === "onChange" ? i.commitValidation(a) : i.commitValidation(a, !0)), o && u && H && !c) {
          const b = a ? [...u, o] : u.filter((Ve) => Ve !== o);
          H(b, t.nativeEvent), V(b.length > 0), N === "onChange" ? i.commitValidation(b) : i.commitValidation(b, !0);
        }
      },
      onFocus() {
        var t;
        (t = f.current) == null || t.focus();
      }
    },
    // React <19 sets an empty value if `undefined` is passed explicitly
    // To avoid this, we only set the value if it's defined
    C !== void 0 ? {
      value: (e ? s && C : C) || ""
    } : Me,
    e ? i.getValidationProps : i.getInputValidationProps
  ), _ = G ? !!q : s, T = G && E || g;
  d.useEffect(() => {
    x && o && x.disabledStatesRef.current.set(o, l);
  }, [x, l, o]);
  const F = d.useMemo(() => ({
    ...S,
    checked: _,
    disabled: l,
    readOnly: h,
    required: k,
    indeterminate: T
  }), [S, _, l, h, k, T]), Ce = Fe(F), ve = be("button", r, {
    state: F,
    ref: [ce, f, X, e == null ? void 0 : e.registerControlRef],
    props: [{
      id: m,
      role: "checkbox",
      disabled: l,
      "aria-checked": E ? "mixed" : s,
      "aria-readonly": h || void 0,
      "aria-required": k || void 0,
      "aria-labelledby": ne,
      [je]: c ? "" : void 0,
      onFocus: me,
      onBlur: pe,
      onClick: he
    }, i.getValidationProps, D, re, se],
    customStyleHookMapping: Ce
  });
  return /* @__PURE__ */ w.jsxs(M.Provider, {
    value: F,
    children: [ve, !s && !e && r.name && !c && /* @__PURE__ */ w.jsx("input", {
      type: "hidden",
      name: r.name,
      value: "off"
    }), /* @__PURE__ */ w.jsx("input", {
      ...ke
    })]
  });
});
process.env.NODE_ENV !== "production" && (Se.displayName = "CheckboxRoot");
export {
  Se as C,
  je as P,
  Fe as a,
  L as b,
  Qe as u
};
